import { memo } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FormattedMessage } from 'react-intl'
import { faWarning } from '@fortawesome/free-solid-svg-icons/faWarning'

interface RiskyParameterDisclaimerProps {
    changeWarning: string
}

export const RiskyParameterDisclaimer = memo(function RiskyParameterDisclaimer(
    props: RiskyParameterDisclaimerProps
) {
    const { changeWarning } = props

    return (
        <div className="d-flex flex-column gap-3 p-2">
            <span
                className="d-flex align-items-start gap-2 p-2"
                style={{
                    fontSize: '1rem',
                    backgroundColor: '#FDF1DF',
                    borderRadius: '2px',
                    padding: '5px',
                }}
            >
                <FontAwesomeIcon
                    className="mt-1"
                    color={'#DBB47A'}
                    icon={faWarning}
                />
                <FormattedMessage id="configuration.riskyParameter" />
            </span>
            <span
                className="d-inline-block"
                style={{ fontSize: '1.125rem' }}
            >
                {changeWarning}
            </span>
        </div>
    )
})
